module.exports = __webpack_public_path__ + "img/spotify-podcasts.d54f4c8a.svg";